const { buildDeck, shuffle } = require("../armenian/deck");

/**
 * Раздача Open Belot: 6 в руку + 5×2 на стол (нижняя + верхняя) на игрока = 32 карты.
 *
 * @param {() => number} rng
 * @returns {{
 *   hands: [number[], number[]],
 *   tableColumns: [Array<{ bottom: number, top: number }>, Array<{ bottom: number, top: number }>],
 * }}
 */
function dealOpenDuell(rng) {
  const deck = buildDeck();
  shuffle(deck, rng);
  let i = 0;
  const take = (n) => {
    if (i + n > deck.length) throw new Error("dealOpenDuell: deck underrun");
    const slice = deck.slice(i, i + n);
    i += n;
    return slice;
  };
  const hand0 = take(6);
  const hand1 = take(6);
  /** @type {Array<{ bottom: number, top: number }>} */
  const cols0 = [];
  /** @type {Array<{ bottom: number, top: number }>} */
  const cols1 = [];
  for (let c = 0; c < 5; c += 1) {
    cols0.push({ bottom: take(1)[0], top: take(1)[0] });
    cols1.push({ bottom: take(1)[0], top: take(1)[0] });
  }
  if (i !== 32) {
    throw new Error(`dealOpenDuell: expected 32 cards consumed, got ${i}`);
  }
  return {
    hands: [hand0, hand1],
    tableColumns: [cols0, cols1],
  };
}

module.exports = {
  dealOpenDuell,
};
